import { Input, Toggle } from '@ixyberfree/ixybercomponents';
import React, { useEffect, useRef } from 'react';
import { IPens } from '../index';
import Tables from '../Tables/Tables';
import style from './style.module.css';

interface ITrendsTable {
    items: IPens[];
    calbackEditItem: any;
    UpdateEnableState: any;
    UpdateMinMax: any;
    // UpdateMax: any;
    callbackClickRow: (name: string) => void;
    handleToggleChange: (item: any, enable: boolean) => void;
    deletePen: (id: number) => void;
}

export interface ITrendView {
    selected?: boolean;
    param: string;
    curvalue?: string;
    desc?: string;
    eudesc?: string;
    min?: any;
    max?: any;
    color?: any;
    enable: boolean;
}

interface ColumnData {
    dataKey: string;
    label: string;
    numeric?: boolean;
    width: any;
    minWidth?: any;
}

interface Row {
    index: number;
}

function GroupTable(props: ITrendsTable) {
    const inputRefs = useRef<{ [key: number]: { min: HTMLInputElement | null; max: HTMLInputElement | null } }>({});

    const UpdateTableInterval = 1000;

    useEffect(() => {
        props.items.forEach((item) => {
            if (inputRefs.current[item.id]) {
                if (inputRefs.current[item.id].min) {
                    inputRefs.current[item.id].min!.value = item.min.toString();
                }
                if (inputRefs.current[item.id].max) {
                    inputRefs.current[item.id].max!.value = item.max.toString();
                }
            }
        });
    }, [props.items]);

    const Update = () => {
        try {
            let cloneHmiHistory = props.items.slice();
            for (let param = cloneHmiHistory.length; param--; ) {
                let parnew = window.parent.GetParam(cloneHmiHistory[param].name);
                cloneHmiHistory[param].curvalue = Number(parnew.V).toFixed(3);
            }
        } catch (ex) {}
    };

    useInterval(Update, UpdateTableInterval);

    function Checked() {
        const checkedIds: string[] = [];

        props.items.forEach((item, index) => {
            if (item.selected === true) {
                checkedIds.push(index.toString());
            }
        });

        return checkedIds;
    }

    const handleClickRow = (item: any) => {
        if (item.name) props.callbackClickRow(item.name);
    };

    function UpdateState(item: { id: any }, checked: any) {
        const newId = Number(item.id) + 1;
        props.UpdateEnableState(newId, checked);
    }

    function handleToggleChange(item: any, enable: boolean) {
        props.handleToggleChange(item, enable);
    }

    const handleInputBlur = (id: number, value: string, param: 'min' | 'max') => {
        const formattedValue = value.replace(',', '.');
        if (value) {
            props.UpdateMinMax(id, formattedValue, param);
        }
    };

    return (
        <Tables
            header={[
                {
                    idCol: 'selected',
                    width: '',
                    label: 'selected',
                    type: 'select'
                },
                {
                    idCol: 'color',
                    width: '30px',
                    label: '',
                    type: 'text',
                    action: false
                },
                {
                    idCol: 'name',
                    width: '20%',
                    label: 'Источник',
                    type: 'text',
                    action: true
                },
                {
                    idCol: 'desc',
                    width: '30%',
                    label: 'Описание',
                    type: 'text'
                },
                {
                    idCol: 'toggle',
                    width: '7%',
                    label: 'руч/авто',
                    type: 'text',
                    action: false
                },
                {
                    idCol: 'min',
                    width: '10%',
                    label: 'Мин.',
                    type: 'number'
                },
                {
                    idCol: 'max',
                    width: '10%',
                    label: 'Макс.',
                    type: 'number'
                },
                {
                    idCol: 'curvale',
                    width: '10%',
                    label: 'Тек. знач.',
                    type: 'number',
                    action: true
                },
                {
                    idCol: 'eudesc',
                    width: '10%',
                    label: 'Ед. измер.',
                    type: 'text'
                },
                {
                    idCol: 'delPen',
                    width: '30px',
                    label: '',
                    type: 'text',
                    action: false
                }
            ]}
            data={props.items.map((item, index) => ({
                color: (
                    <div
                        id={String(item.id)}
                        title={item.color}
                        style={{ width: '15px', height: '15px', backgroundColor: item.color }}
                        onClick={(e) => {
                            e.stopPropagation();
                            props.calbackEditItem(e, item.id);
                        }}></div>
                ),
                name: item.name,
                desc: item.desc,
                toggle: (
                    <div className={style.Toggle} onClick={(e) => e.stopPropagation()}>
                        <Toggle
                            id={`${String(item.id)}`}
                            label=""
                            checked={item.enable}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                handleToggleChange(item, e.target.checked);
                            }}
                        />
                    </div>
                ),
                min: (
                    <Input
                        id={String(item.id)}
                        type="text"
                        defaultValue={item.min}
                        disabled={item.enable}
                        ref={(el) => {
                            if (!inputRefs.current[item.id]) inputRefs.current[item.id] = { min: null, max: null };
                            inputRefs.current[item.id].min = el;
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                e.currentTarget.blur();
                            }
                        }}
                        onBlur={(e) => handleInputBlur(item.id, e.target.value, 'min')}
                    />
                ),
                max: (
                    <Input
                        id={String(item.id)}
                        type="text"
                        defaultValue={item.max}
                        disabled={item.enable}
                        ref={(el) => {
                            if (!inputRefs.current[item.id]) inputRefs.current[item.id] = { min: null, max: null };
                            inputRefs.current[item.id].max = el;
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                e.currentTarget.blur();
                            }
                        }}
                        onBlur={(e) => handleInputBlur(item.id, e.target.value, 'max')}
                    />
                ),
                curvale: Number(item.curvalue).toFixed(3),
                eudesc: item.eudesc,
                delPen: item.name && (
                    <svg
                        className={style.delPenSvgIcon}
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                            props.deletePen(index);
                        }}>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM5.23644 4.64002C5.39234 4.63867 5.54251 4.69866 5.65461 4.80703L5.65663 4.80899L8.00006 7.1556L10.3471 4.80789C10.4592 4.69951 10.6094 4.63954 10.7653 4.64089C10.9212 4.64225 11.0703 4.70484 11.1805 4.81515C11.2907 4.92545 11.3532 5.07463 11.3545 5.23055C11.3559 5.38646 11.296 5.5367 11.1877 5.6489L11.1858 5.65092L8.8409 7.99727L11.1858 10.3436C11.241 10.3989 11.2848 10.4646 11.3147 10.5368C11.3446 10.609 11.36 10.6864 11.36 10.7646C11.36 10.8428 11.3446 10.9202 11.3147 10.9924C11.2848 11.0646 11.241 11.1303 11.1858 11.1856C11.1306 11.2409 11.065 11.2847 10.9928 11.3147C10.9206 11.3446 10.8432 11.36 10.765 11.36C10.6869 11.36 10.6095 11.3446 10.5373 11.3147C10.4651 11.2847 10.3995 11.2409 10.3443 11.1856L8.00041 8.83854L5.65572 11.1856C5.54415 11.2972 5.39281 11.36 5.23496 11.36C5.07712 11.36 4.92577 11.2972 4.8142 11.1856C4.70264 11.0739 4.64 10.9225 4.64 10.7646C4.64 10.6068 4.70264 10.4553 4.8142 10.3437L7.15916 7.99721L4.81398 5.64805C4.70572 5.53585 4.64586 5.38559 4.64721 5.22968C4.64857 5.07376 4.71104 4.92458 4.82123 4.81428C4.93143 4.70398 5.08053 4.64138 5.23644 4.64002Z"
                            fill="#CCCCCC"
                        />
                    </svg>
                )
            }))}
            onCheck={UpdateState}
            onClickRow={handleClickRow}
            checked={Checked()}
            cssClassHead="header__style"
            cssClassBody="body__style"
            width="100%"
            // width='1160px'
            height="100%"
        />
    );
}

export default GroupTable;

function useInterval(callback: any, delay: any) {
    const savedCallback: any = React.useRef();

    // Remember the latest callback.
    React.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    React.useEffect(() => {
        function tick() {
            if (savedCallback) savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}
